import { useAuth } from "../context/AuthContext";

export const PLATFORM_ROLE = { super_admin: "Super administrateur", director: "Directeur", sales: "Commercial", support: "Support",
  accountant: "Comptable", marketing: "Responsable marketing", analyst: "Analyste" };

export const usePlatformCan = () => {
  const { user } = useAuth();
  const perms = user?.platform_permissions || [];
  return (...keys) => keys.some((k) => perms.includes(k));
};

export const AUDIT_CATEGORY = { permissions: "Permissions & rôles", suspensions: "Suspensions / réactivations", deletions: "Suppressions",
  invoices: "Factures & abonnements", moderation: "Modération", settings: "Paramètres", companies: "Décisions entreprises" };

export const DECISION = { refused: "Refus", active: "Approbation", reactivated: "Réactivation", suspended: "Suspension", terminated: "Résiliation",
  "verify.verified": "Vérification validée", "verify.needs_info": "Vérification : informations manquantes", pending: "Remise en attente", draft: "Retour brouillon" };

export const VERIFY_CHECKS = { email: "Email professionnel confirmé", identity: "Identité du demandeur", legal: "Existence légale (raison sociale, n° fiscal)", contact: "Coordonnées joignables" };

export const MODERATION_ACTION = { restricted: "Restriction (masqué publiquement)", report_dismissed: "Signalement rejeté", restored: "Restriction levée" };

export const REF_TYPE = { sector: "Secteurs d'activité", category: "Catégories d'avis", country: "Pays", language: "Langues", currency: "Devises" };
